import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import { AuthenticationService } from './authentication.service';
import { ApiResponse } from 'src/app/main/_models/api-response';

@Injectable({
	providedIn: 'root'
})
export class CheckProfileService {

	private warningCheckProfile: boolean;
	private messages = [];
	checkProfileData: Subject<any> = new Subject<boolean>();

	constructor(private http: HttpClient,
		private config: AppConfig,
		private authenticationService: AuthenticationService) { }

	checkprofile() {
		return this.http.get<ApiResponse>(`${this.config.getConfig("apiEndpoint")}/users/checkprofile`);
	}

	setWarningCheckProfile(warning) {
		this.warningCheckProfile = warning;
		this.checkProfileData.next({
			warningCheckProfile: this.warningCheckProfile,
			messages: this.messages
		});
	}

	getWarningCheckProfile() {
		return this.warningCheckProfile;
	}

	getMessages() {
		let currentUser;
		this.authenticationService.currentUser.subscribe(x => currentUser = x);
		if (currentUser && currentUser.profilo === 'P') {
			this.checkprofile().subscribe(
				data => {
					this.messages = data.result;
					if (this.messages.length > 0) {
						this.warningCheckProfile = true;
					} else {
						this.warningCheckProfile = false;
					}
					this.checkProfileData.next({
						warningCheckProfile: this.warningCheckProfile,
						messages: this.messages
					});
				},
				error => {
					this.warningCheckProfile = false;
					this.checkProfileData.next({
						warningCheckProfile: this.warningCheckProfile,
						messages: this.messages
					});
				});
		}
	}

}
